import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to the element matching location.hash whenever the route
 * changes. React Router does not auto-scroll to hashes by default,
 * so this handles both in-page clicks and cross-route hash links
 * like <Link to="/#safety" />.
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      // New route without hash — reset scroll to top.
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      return;
    }
    const id = decodeURIComponent(hash.slice(1));
    // Wait a tick so the target route/section is mounted.
    const scroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    // Try immediately and again shortly after in case of code-splitting.
    scroll();
    const t = setTimeout(scroll, 120);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
}
